const qs = require('query-string')

export function Filter(q) {
	for (var k in q) {
		if (q[k]==='') {
			delete q[k]
		}
	}
	return (q) ? '?'+qs.stringify(q) : '';
}
